import { Divider, Box, Card, CardContent, Container, Grid, Pagination, Typography } from "@mui/material";
import { useLearnerContext } from "../hooks/useLearnerContext";
import { IPerson } from "../types/interfaces/IPerson";
import { useState } from "react";

//This component is responsible for displaying the advisor list for the ilp. 
export default function AdvisorList() {
    const { individualLearningPlan } = useLearnerContext();
    const advisors: IPerson[] | any = individualLearningPlan?.AvailableReviewers;
    const [page, setPage] = useState(1);
    const advisorsPerPage = 3;
    const count = Math.ceil(advisors.length/advisorsPerPage);

    //Function to handle the page change.
    const pageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };
    
    return (
        <>
            <Typography variant="h6" color="black" component="div">
            <Box sx={{ fontWeight: 'bold'}}>Program Administrators and Advisors</Box>
            </Typography>
            <Grid container spacing={1} sx={{ mt:1, mb:1}}>
                {advisors.slice((page - 1) * advisorsPerPage, page * advisorsPerPage).map((advisor: IPerson[] | any ) => (
                    <Grid item xs={12} sm={6} md={4} key={advisor.CustomerKey} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Card sx={{ border: 1, borderColor: 'divider' }}>
                            <CardContent>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>Name:</Typography>
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{advisor.FirstName} {advisor.LastName}</Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>Email:</Typography>
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{advisor.Email}</Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Pagination count={count} page={page} onChange={pageChange} variant="outlined" shape="rounded" showFirstButton showLastButton sx={{ mb:5}} />
            <Divider sx={{mt:1, mb:5}}></Divider>
        </>
    );
}